module.exports = Aliplayer;


//////////////////
// WEBPACK FOOTER
// external "Aliplayer"
// module id = D6Sk
// module chunks = 3